export default __webpack_public_path__ + "static/national-metric-desktop-e92b7f2688e3ef7dbc15e34850f81a39.svg";